"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var buttons_1 = require("../buttons");
var TextInput_1 = require("../TextInput");
var Typography_1 = require("../Typography");
var DatePickerContent_1 = require("./DatePickerContent");
var hooks_1 = require("./hooks");
var mask_1 = require("./mask");
var types_1 = require("./types");
var DatePicker = function (_a) {
    var dataTestId = _a["data-testid"], placeholder = _a.placeholder, disabled = _a.disabled, icon = _a.icon, useActionButtons = _a.useActionButtons, closeOnSelect = _a.closeOnSelect, _b = _a.cancelButtonText, cancelButtonText = _b === void 0 ? 'Cancel' : _b, _c = _a.selectButtonText, selectButtonText = _c === void 0 ? 'Choose date' : _c, _d = _a.currentDayText, currentDayText = _d === void 0 ? 'Current day' : _d, _e = _a.selectedDayText, selectedDayText = _e === void 0 ? 'Selected day' : _e, _f = _a.weekDays, weekDays = _f === void 0 ? types_1.defaultWeekDaysText : _f, _g = _a.months, months = _g === void 0 ? types_1.defaultMonthText : _g, value = _a.value, disableBefore = _a.disableBefore, disableAfter = _a.disableAfter, onChange = _a.onChange, parentRef = _a.parentRef, _h = _a.position, position = _h === void 0 ? 'left' : _h, _j = _a.format, format = _j === void 0 ? 'yyyy-MM-dd' : _j, containerClassName = _a.containerClassName;
    var _k = (0, react_1.useState)(false), open = _k[0], setOpen = _k[1];
    var _l = (0, react_1.useState)(value), selectedDate = _l[0], setSelectedDate = _l[1];
    var inputRef = (0, react_1.useRef)(null);
    var dropDownRef = (0, react_1.useRef)(null);
    var cancelButtonRef = (0, react_1.useRef)(null);
    var selectButtonRef = (0, react_1.useRef)(null);
    var contentRef = (0, react_1.useRef)(null);
    var _m = (0, react_1.useState)(value), dateValue = _m[0], setDateValue = _m[1];
    (0, react_1.useEffect)(function () {
        var handleClickOutside = function (event) {
            var _a, _b, _c, _d;
            if (!((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                if ((useActionButtons &&
                    (((_b = cancelButtonRef === null || cancelButtonRef === void 0 ? void 0 : cancelButtonRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target)) ||
                        ((_c = selectButtonRef === null || selectButtonRef === void 0 ? void 0 : selectButtonRef.current) === null || _c === void 0 ? void 0 : _c.contains(event.target)))) ||
                    (!useActionButtons &&
                        closeOnSelect &&
                        !((_d = contentRef.current) === null || _d === void 0 ? void 0 : _d.isClicked(event.target)))) {
                    setOpen(false);
                }
            }
        };
        window.addEventListener('click', handleClickOutside);
        return function () {
            window.removeEventListener('click', handleClickOutside);
        };
    }, [
        inputRef,
        cancelButtonRef,
        selectButtonRef,
        contentRef,
        useActionButtons,
    ]);
    var style = (0, hooks_1.useDatePickerPositioning)(inputRef, dropDownRef, open, parentRef, position);
    var handleTextInputChange = function (input) {
        if ((input === null || input === void 0 ? void 0 : input.trim().length) >= 4) {
            try {
                var date = (0, date_fns_1.parse)((0, mask_1.maskDate)(input.trim(), format), format, new Date());
                if (!date.toString().toLowerCase().includes('invalid') &&
                    date.getFullYear().toString().length >= 4) {
                    var disabled_1 = (!!disableBefore && date < disableBefore) ||
                        (!!disableAfter && disableAfter < date);
                    if (!disabled_1) {
                        setSelectedDate(date);
                        setDateValue(date);
                        if (!useActionButtons) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(date);
                        }
                    }
                }
                // eslint-disable-next-line no-empty
            }
            catch (e) { }
        }
    };
    var handleContentSelectDate = function (date) {
        setSelectedDate(date);
        setDateValue(date);
        if (!useActionButtons) {
            onChange === null || onChange === void 0 ? void 0 : onChange(date);
            if (closeOnSelect) {
                setOpen(false);
            }
        }
    };
    var handleCancel = function () {
        setSelectedDate(undefined);
        setDateValue(new Date());
    };
    var handleChange = function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(selectedDate);
    };
    var handleFocus = function () {
        setOpen(true);
    };
    var handleToggle = function () {
        setOpen(true);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)('squid-relative squid-inline-block', containerClassName) }, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "".concat(dataTestId, "Button"), onClick: handleToggle, ref: inputRef, className: "squid-w-full" }, { children: (0, jsx_runtime_1.jsx)(TextInput_1.TextInput, { placeholder: placeholder, disabled: disabled, icon: icon, value: selectedDate ? (0, date_fns_1.format)(selectedDate, format) : '', onFocus: handleFocus, onChange: handleTextInputChange, "data-testid": dataTestId }) })) }), open && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "\n          squid-absolute\n          squid-my-2\n          squid-z-50 \n          squid-flex \n          squid-flex-col \n          squid-w-80 \n          squid-px-[20px] \n          squid-py-[16px] \n          squid-border \n          squid-border-alias-color-border-base \n          squid-bg-alias-color-bg-base \n          squid-rounded-core-border-radius-md\n          ", style: style, ref: dropDownRef, "data-testid": "".concat(dataTestId, "Menu") }, { children: [(0, jsx_runtime_1.jsx)(DatePickerContent_1.default, { forwardedRef: contentRef, onChange: handleContentSelectDate, value: dateValue, selectedValue: selectedDate, disableBefore: disableBefore, disableAfter: disableAfter, months: months, weekDays: weekDays, "data-testid": dataTestId }), useActionButtons && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-items-center squid-justify-center squid-gap-[20px] squid-my-4" }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "squid-flex squid-items-center squid-gap-1" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "squid-w-2 squid-h-2 squid-border squid-border-alias-color-border-active squid-rounded-full" }), (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: false, className: "squid-text-alias-color-text-weaker squid-text-center" }, { children: currentDayText }))] })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "squid-flex squid-items-center squid-gap-[4px]" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "squid-w-2 squid-h-2 squid-bg-alias-color-bg-primary squid-rounded-full" }), (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: false, className: "squid-text-alias-color-text-weaker squid-text-center" }, { children: selectedDayText }))] }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-p-4 squid-gap-4 squid-border-t squid-items-center squid-justify-evenly squid-border-alias-color-border-base" }, { children: [(0, jsx_runtime_1.jsx)(buttons_1.Button, __assign({ variant: "critical", onClick: handleCancel, size: "sm", forwardedRef: cancelButtonRef }, { children: cancelButtonText })), (0, jsx_runtime_1.jsx)(buttons_1.Button, __assign({ variant: "primary", onClick: handleChange, size: "sm", forwardedRef: selectButtonRef }, { children: selectButtonText }))] }))] }))] })))] })));
};
exports.DatePicker = DatePicker;
